import Iain from './players/17038-Iain McDougall.json';
import Harry from './players/110254-Harry Messenger.json';
import Noah from './players/111132-Noah Smithson.json';
import Adam from './players/112073-Adam Mackrory.json';
import Sharkey from './players/113299-Michael Sharkey.json';
import James from './players/113303-James Cooney.json'
import Josh from './players/116913-Josh Birmingham.json';
import Jamie from './players/120671-Jamie Matthews.json';
import Matt from './players/142539-Matt Parslow.json';
import Oliver from './players/143441-Oliver Harris.json';
import Rachel from './players/144658-Rachel Turton.json';
import Max from './players/145463-Max Humphries.json';
import Steve from './players/149775-Steve Nolan.json';
import RachelIJ from './players/150733-Rachel Ireland-Jones.json';
import Stan from './players/163789-Stan Valentine.json';
import Ben from './players/174343-Ben Holding.json';
import Fergus from './players/176700-Fergus McLean.json';
import Natalie from './players/184608-Natalie Pitt.json';
import Elva from './players/184609-Elva-Kate Preston.json';

const AdgTeam = [Iain, Harry, Noah, Adam, James, Sharkey, Josh, Jamie, Matt, Oliver, Rachel, Max, Steve, RachelIJ, Stan, Ben, Fergus, Natalie, Elva];

export default AdgTeam;